import React, { useState } from "react";
import close from "../Assets/Images/close.png";
import TextInput from "./Inputs/TextInput";
import { formHandler } from "../utils/formhandler";
import { sellUnits } from "../store/actions/realEstate/sellUnits";
import { useDispatch } from "react-redux";
import { sellUnitsSchema } from "../helper/validationSchemas";
import { useFormik } from "formik";

const PublishToSelectedUsers = ({ handleClose, setIsModalOpen }) => {
  const dispatch = useDispatch();

  const handleSubmit = (values, { setSubmitting }) => {
    dispatch(
      sellUnits({
        data: {},
        cb: () => {
          setSubmitting(false);
        },
        failed: () => {
          setSubmitting(false);
        },
      })
    );
  };

  const form = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: handleSubmit,
    validationSchema: sellUnitsSchema,
    validateOnMount: false,
    validateOnBlur: false,
    validateOnChange: false,
  });

  return (
    <div className="flex flex-col justify-between items-start border-[1px] border-[#F0F0F5] w-[553px] mt-[30px] pt-8 pb-6 mx-auto mb-[30px] h-[322px] rounded-[14px] shadow-xl relative bg-white">
      <div className="absolute top-5 right-6 cursor-pointer">
        <img
          src={close}
          alt="Close"
          className=" curvsor-pointer w-6 h-6"
          onClick={handleClose}
        />
      </div>
      <div className="flex flex-col justify-start items-center w-full">
        <h2 className="text-[16px] text-[#131e3d] font-[400] mb-4">
          Publish to selected users
        </h2>
      </div>

      <div className="flex px-8 w-full flex-col gap-2">
        <label className="text-[14px] font-[400] text-[#9C9C9E]">
          Email Address
        </label>
        <TextInput
          {...formHandler("email", form)}
          mainClasses={"mb-0 mt-0 !w-full "}
        />
      </div>

      <div className="flex justify-center w-full ">
        <button
          onClick={() => {
            setIsModalOpen({ modal: "CONFIRMATION" });
          }}
          className="w-[203px] h-[45px] rounded-[8px] bg-[#6935D3] shadow-sm flex justify-center items-center font-[500] text-[16px] text-white"
        >
          Publish
        </button>
      </div>
    </div>
  );
};

export default PublishToSelectedUsers;
